import { ACADEMIC_FIELD_CONFIGS } from './academic.config';
import { CAREER_FIELD_CONFIGS } from './career.config';
import { DOCUMENTS_FIELD_CONFIGS } from './documents.config';
import { FINANCIAL_FIELD_CONFIGS } from './financial.config';
import { HEALTH_FIELD_CONFIGS } from './health.config';
import { INTERESTS_FIELD_CONFIGS } from './interest.config';
import { PROFILE_FIELD_CONFIGS } from './profile.config';
import { RELATIONSHIPS_FIELD_CONFIGS } from './relationship.config';
import { STORY_FIELD_CONFIGS } from './story.config';

export const FIELD_CONFIGS = {
  ...PROFILE_FIELD_CONFIGS,
  ...ACADEMIC_FIELD_CONFIGS,
  ...CAREER_FIELD_CONFIGS,
  ...INTERESTS_FIELD_CONFIGS,
  ...RELATIONSHIPS_FIELD_CONFIGS,
  ...HEALTH_FIELD_CONFIGS,
  ...FINANCIAL_FIELD_CONFIGS,
  ...DOCUMENTS_FIELD_CONFIGS,
  ...STORY_FIELD_CONFIGS,
} as const;
